import React, { Fragment } from "react"
import { Row, Col, Form } from 'react-bootstrap'
import { formatPathogenName } from '../reducers/infectionCourseFormReducer'

const PathogenSelectionOption = (props) => {


	const {
    // data
    pathogen,
    option,
    optionIsSelected,
    site,
    disabled,
    required,
    primary_infection_sites,
  
    // functions
    getValue,
    updatePathogen,
    handlePathogenSelect,
    handlePathogenBlur,
	} = props


  const handlePathogenNestedFieldsChange = (e, option) => {
    //because of nested nature of primaryInfectionSites, this function finds the correct primaryInfectionSite in props, structures data accordindly and dispatches data to change state
    const { name, value } = e.target
    let pathogenName
    if (option.displayName) {
      pathogenName = option.displayName
    } else {
      pathogenName = option
    }
    let foundPathogen = props.site.pathogens.find(pathogen => {
      if (option.id) {
        return option.id === pathogen.id
      } else {
        return pathogen.name === pathogenName
      }
    })

    return updatePathogen(primary_infection_sites, props.site, foundPathogen, name, value)
  }

	let pathogenIdAndName = ''

	if (props.site && props.site.id) {
		pathogenIdAndName = `${props.site.infection_site}-${props.site.id}`
	}

  return (
    <Row style={{ paddingTop: "0" }}>
      <Col xs={12} sm={12} md={8} lg={6}>
        <Form.Check
          id={`${pathogenIdAndName}-${option.fieldName}`}
          name={`${pathogenIdAndName}-${option.fieldName}`}
          label={option.displayName === "Other" ? option.displayName : <i>{formatPathogenName(option.displayName)}</i>}
          value={optionIsSelected}
          checked={optionIsSelected}
          disabled={disabled}
          onChange={(e) => handlePathogenSelect(option.displayName, !optionIsSelected, site, option.id)}
          required={required}
        />
        {optionIsSelected && option.textFields && option.textFields.length > 0
          ?
          <Fragment>
            {option.textFields.map(textField => {
              return (
                <Row key={textField.fieldName} style={{ marginBottom: '10px' }}>
                  <Col xs={10} sm={10} md={10} lg={10}>
                    <Form.Label>
                      {textField.displayName}
                    </Form.Label>
                    <Form.Control
                      key={textField.fieldName}
                      className='text-option-checkbox-form'
                      name={textField.fieldName}
                      autoComplete={getValue(option, textField.fieldName)}
                      value={getValue(option, textField.fieldName)}
                      disabled={disabled}
                      placeholder={textField.displayName}
                      required={true}
                      onClick={props.handleNestedFieldClick ? () => props.handleNestedFieldClick(pathogen) : () => null}
                      onChange={props.preventChange ? () => null : (e) => handlePathogenNestedFieldsChange(e, option)}
                      onBlur={props.preventChange ? () => null : () => handlePathogenBlur(site, pathogen)}
                    />
                  </Col>
                </Row>
              )
            })}
          </Fragment>
          :
          null
        }
      </Col>
    </Row>
  )
}

export default PathogenSelectionOption
